import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import CommentButton from '../../buttons/CommentButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import MoreButton from '../../buttons/MoreButton';
import s from './SimpleActionBar.scss';
const SimpleActionBar = ({ deviation, isOwner })=>{
    const { hasMoreActions, isCommentable, isEditable, isDeletable } = useDeviationAttributes(deviation, isOwner);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, null, /*#__PURE__*/ React.createElement(CentralColumn, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-side']
    }, isCommentable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-side']
    }, isDeletable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), isEditable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })))));
};
SimpleActionBar.displayName = 'SimpleActionBar';
export default SimpleActionBar;

//# sourceMappingURL=SimpleActionBar.js.map